import { Zoom as MuiZoom, ZoomProps as MuiZoomProps } from '@mui/material'
import styled from 'styled-components'

export type ZoomPropsType = MuiZoomProps

const Zoom = styled(MuiZoom)<ZoomPropsType>``

export default Zoom
